import React, { useEffect, useState } from 'react';
import api from '../services/api';
import type StudyModel from '../models/StudyModel';
import type SlideModel from '../models/SlideModel';
import LoadingSpinner from './LoadingSpinner';
import StudySearchField from './StudySearchField';
import SlideSearchField from './SlideSearchField';

type PropTypes = {
    onSlideCreated: () => void;
    study?: StudyModel;
};

function CreateStudySlideForm({ onSlideCreated, study }: PropTypes) {
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [selectedStudy, setSelectedStudy] = useState(
        study ?? ({} as StudyModel), // eslint-disable-line @typescript-eslint/consistent-type-assertions
    );
    const [selectedSlide, setSelectedSlide] = useState({} as SlideModel);

    useEffect(() => {
        setError('');
    }, [selectedStudy, selectedSlide]);

    const handleSubmit = async () => {
        if (!selectedStudy || !selectedSlide) {
            setError('All fields are required');
            return;
        }

        setLoading(true);
        const success = await api.addSlideToStudy(
            Number(selectedStudy.id),
            Number(selectedSlide.id),
        );
        setLoading(false);
        if (success) {
            onSlideCreated();
        } else {
            setError('Failed to add slide to study. Please try again later.');
        }
    };

    return (
        <div className="w-[300px]">
            {!study && (
                <div className="mt-2 flex items-center justify-between">
                    <label>Study:</label>
                    <StudySearchField
                        selectedStudy={selectedStudy}
                        setSelectedStudy={setSelectedStudy}
                    />
                </div>
            )}
            <div className="mt-2 flex items-center justify-between">
                <label>Slide:</label>
                <SlideSearchField
                    selectedSlide={selectedSlide}
                    setSelectedSlide={setSelectedSlide}
                />
            </div>
            {error && <div className="text-red-500 mt-2">{error}</div>}
            <button
                type="submit"
                className="btn btn-primary mt-6"
                disabled={loading || error !== ''}
                onClick={handleSubmit}
            >
                {loading ? <LoadingSpinner size={30} /> : 'Add Slide To Study'}
            </button>
        </div>
    );
}

export default CreateStudySlideForm;
